import commonObj from '../../../utils/Common';

const PriceDetailsCard = ({
  totalItems,
  actualPriceOfCart,
  totalPriceOfCartProducts,
  adminFee,
  deliveryDate,
  cartCurrency
}) => {
  //console.log(deliveryDate)
  const summaryData = [
    { label: commonObj.getLabel('Total_Products'), value: totalItems },
    {
      label: commonObj.getLabel('Subtotal'),
      value: `${cartCurrency}${actualPriceOfCart}`,
    },
    {
      label: commonObj.getLabel('Service_Tax'),
      value: `${cartCurrency}${adminFee}`,
    },
    // {
    //   label: commonObj.getLabel('Discount'),
    //   value: `-${commonObj.getCurrency('mn')}${actualPriceOfCart - totalPriceOfCartProducts}`,
    // },
    {
      label: commonObj.getLabel('Delivery_Date'),
      value: deliveryDate > '0' ? deliveryDate :(<input type="datetime-local" name="deliveryDate" id="deliveryDate" min={new Date().toISOString().slice(0, 16)} />),
    },
  ];

  return summaryData.map(({ label, value }) => (
    <div key={label} className=" flex justify-between items-center p-0 cart-7">
      <p className=" text-gray-600">{label}</p>
      <p className="text-lg">{value}</p>
    </div>
  ));
};
export default PriceDetailsCard;
